import { Mapper } from "../../../../base/utils/mapper";

import { DocumentsSystemModel }
from "../../../../domain/models/configuration/documents-system.model";

import { DocumentsSystemEntity }
from "../entities/documents-system.entity";

export class DocumentsSystemImplementationRepositoryMapper
extends Mapper<
DocumentsSystemEntity,
DocumentsSystemModel
> {

    mapFrom(param:
    DocumentsSystemEntity):
    DocumentsSystemModel {

        return {
            ...param
        };
    }

    mapTo(param:
    DocumentsSystemModel):
    DocumentsSystemEntity {

        return {
            ...param
        };
    }
}